module.exports = __webpack_public_path__ + "static/img/logo_bottom@2x.48d47bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/logo_bottom@2x.png
// module id = fEJA
// module chunks = 0